import { koComponent } from '../ko-utils';

class NotInstalledDialog {
    constructor(params, initParams) {
        this.initParams = initParams;
    }

    tryLaunchAnyway() {
        if (this.initParams && this.initParams.action) {
            this.initParams.action();
        }
    }
}

export default koComponent('not-installed-dialog', NotInstalledDialog);